module.exports = __webpack_public_path__ + "img/validation_blue_250px.6b683ca3.svg";